import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/whatWeOffer",
    name: "WhatWeOffer",
    component: () => import("../views/WhatWeOffer.vue"),
  },
  {
    path: "/whoWeAre",
    name: "WhoWeAre",
    component: () => import("../views/WhoWeAre.vue"),
  },
  {
    path: "/faqs",
    name: "Faqs",
    component: () => import("../views/Faqs.vue"),
  },
  {
    path: "/ourTeam",
    name: "OurTeam",
    component: () => import("../views/OurTeam.vue"),
  },
  {
    path: "/blog",
    name: "Blog",
    component: () => import("../views/Blog.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
  },
  {
    path: "/paymentsReduced",
    name: "PaymentsReduced",
    component: () => import("../views/PaymentsReduced.vue"),
  },
  {
    path: "/personalizedDebt",
    name: "PersonalizedDebt",
    component: () => import("../views/PersonalizedDebt.vue"),
  },
  {
    path: "/debtLoadBreak",
    name: "DebtLoadBreak",
    component: () => import("../views/DebtLoadBreak.vue"),
  },
  {
    path: "/howItWorks",
    name: "HowItWorks",
    component: () => import("../views/HowItWorks.vue"),
  },
  {
    path: "/blog/:id",
    name: "Post",
    component: () => import("../views/Post.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/notFound.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
